import NavBarCtrl from './NavBarCtrl';

export default function () {
    return {
        restrict: 'EA',
        controller: NavBarCtrl
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/directives/NavBarDirective.js
// module id = 871
// module chunks = 0